import { render, staticRenderFns } from "./SendReceiveMoney.vue?vue&type=template&id=d885aea8&scoped=true"
import script from "./SendReceiveMoney.vue?vue&type=script&lang=js"
export * from "./SendReceiveMoney.vue?vue&type=script&lang=js"
import style0 from "./SendReceiveMoney.vue?vue&type=style&index=0&id=d885aea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d885aea8",
  null
  
)

export default component.exports